import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import {
    SavedReportType2 as SavedReportType,
    PushReportConfigurationFrequency,
} from "api/generated/model";

export function formatSavedReportType(
    type: SavedReportType,
    t: TFunction
): string {
    switch (type) {
        case SavedReportType.status:
            return t("User_SavedReportType_Status");
        case SavedReportType.workload:
            return t("User_SavedReportType_Workload");
        case SavedReportType.classification:
            return t("User_SavedReportType_Classification");
        default:
            return assertNever(type);
    }
}

export function formatPushReportFrequency(
    frequency: PushReportConfigurationFrequency,
    t: TFunction
): string {
    switch (frequency) {
        case PushReportConfigurationFrequency.Date:
            return t("SavePushReportConfiguration_ReportType_AdHoc");
        case PushReportConfigurationFrequency.Weekly:
            return t("SavePushReportConfiguration_Weekly");
        case PushReportConfigurationFrequency.Monthly:
            return t("SavePushReportConfiguration_Monthly");
        default:
            return assertNever(frequency);
    }
}

/** Ad hoc first, then ascending interval — the label order would be alphabetical and meaningless. */
export const FREQUENCY_SORT_INDEX: Record<
    PushReportConfigurationFrequency,
    number
> = {
    [PushReportConfigurationFrequency.Date]: 0,
    [PushReportConfigurationFrequency.Weekly]: 1,
    [PushReportConfigurationFrequency.Monthly]: 2,
};
